import './components/script/general';
import 'bootstrap/dist/css/bootstrap.min.css';

import Nav from './components/Nav';
import Header from './components/Header';
import Services from './components/Services';
import Portofolio from './components/Portofolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingItem from './components/Floating';

function App() {

  return (
    <div>
        <Nav />
        <Header />        
        <Services />
        <Portofolio />
        <Contact />
        <Footer />

        <FloatingItem />
    </div>
  );

}

export default App;